// extracted by mini-css-extract-plugin
export var downArrow = "_8c-0";
export var infoTooltipIcon = "_8c-3";
export var label = "_8c-1";
export var optionCard = "_8c-4";
export var upArrow = "_8c-2";